import React from 'react'

export default function InputWithOptions({ inputProps, InputProps, inputRef, label, validity, value, onChange, name, mr }) {
  return (
    <div {...InputProps} style={{paddingRight: "0"}}>
      <input
        ref={inputRef}
        {...inputProps}
        type="text"
        value={value}
        name={name}
        onChange={onChange}
        placeholder={label}
        style={{
          width: `calc(100% - ${mr})`,
          borderColor: value && !validity ? 'red' : '',
        }}
      />
    </div>
  );
}
